import { ProviderManager } from './ProviderManager';
import { SafeMath } from '../utils/SafeMath';

export class GasManager {
    static async estimateGas(contract, method, args, value = 0) {
        try {
            const provider = ProviderManager.getInstance().getProvider();
            const signer = ProviderManager.getInstance().getSigner();

            // Check user's balance first
            const address = await signer.getAddress();
            const balance = await provider.getBalance(address);

            // Get gas price
            const feeData = await provider.getFeeData();
            const gasEstimate = await contract.estimateGas[method](...args, { value });
            const gasLimit = gasEstimate.mul(120).div(100); // Add 20% buffer

            const maxPriorityFeePerGas = feeData.maxPriorityFeePerGas.mul(110).div(100);
            const maxFeePerGas = feeData.maxFeePerGas.mul(110).div(100);

            // Calculate total cost (gas * gas price + value)
            const totalGasCost = gasLimit.mul(maxFeePerGas);
            const totalCost = totalGasCost.add(value);

            // Check if user has enough funds
            if (balance.lt(totalCost)) {
                const needed = SafeMath.formatEther(totalCost);
                const has = SafeMath.formatEther(balance);
                const mintCost = SafeMath.formatEther(value);
                const gasCost = SafeMath.formatEther(totalGasCost);

                throw new Error(
                    `Insufficient funds. You have ${has} ETH but need ${needed} ETH ` +
                    `(${mintCost} ETH for mint + ${gasCost} ETH for gas)`
                );
            }

            return {
                gasLimit,
                maxFeePerGas,
                maxPriorityFeePerGas
            };
        } catch (error) {
            // If it's our custom error, throw it directly
            if (error.message.includes('Insufficient funds')) {
                throw error;
            }

            // Check if the error is an RPC error about insufficient funds
            if (
                error.code === -32603 &&
                error.data?.message?.includes('insufficient funds')
            ) {
                throw new Error(
                    'Insufficient funds to pay for gas and mint price. Please add more ETH to your wallet.'
                );
            }

            console.error('Gas estimation error:', error);
            throw new Error(error.reason || 'Failed to estimate gas');
        }
    }
}